import React from 'react';
import { motion } from 'framer-motion';

const AboutClients: React.FC = () => {
  const clientLogos = [
    '3Ktv.png',
    'Africare.png',
    'AHPCZ logo.png',
    'AngloAmerican.png',
    'CA.png',
    'Caritas.png',
    'CCJP.png',
    'CIAT.png',
    'CIMMYT_logo.png',
    'CNFA.png',
    'Crediconnect.png',
    'Dallaglio Full Black 3.png',
    'Empretec.png',
    'FC.png',
    'Firefight.png',
    'FOTE.png',
    'Glytime.png',
    'Harvest Plus Logo.jpg',
    'HIT.png',
    'HWEDZA RDC logo.png',
    'ILO.png',
    'LRF.png',
    'NGO Forum.png',
    'Pogos.png',
    'PowerGiants.png',
    'Surdax.png',
    'virl logo.png',
    'YA.png',
    'ZBC.png',
    'zera logo.png'
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-black"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: '-0.05em'
            }}
          >
            Trusted by
          </h2>
        </motion.div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-8 md:gap-12">
          {clientLogos.map((logo, index) => (
            <motion.div
              key={logo}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="flex items-center justify-center p-4"
            >
              <img
                src={`/client logos/${logo}`}
                alt={logo.replace(/\.(png|jpg)$/i, '')}
                className="max-w-full max-h-24 md:max-h-32 lg:max-h-40 object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutClients;
